import template from './employee_view_bursaries_component.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

//TO DO: Cannot always save of edit, unsure about error in API

class EmployeeViewBursariesComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.loader = ko.observable(false);
		this.employee = ko.observable();
		this.employee_id = ko.observable();
		this.logged_in_employee_id = ko.observable(Utils.get_local_storage_nullable('employee_id'));
		this.employee_id(this.logged_in_employee_id);

		// bursaries
		this.bursaries = ko.observableArray();
		this.edit_allowed = ko.observable(false);

		this.yes_no_options = [
			{ label: "Yes", value: true },
			{ label: "No", value: false }
		];

		if (bindings.employee && ko.isObservable(bindings.employee))
		{
			bindings.employee.subscribe((nv) => {
				if (nv)
				{
					this.employee(nv);
					this.employee_id(nv.employee_id);
					this.loadPage();
				}
			});
		}

		if (bindings.employee_id && ko.isObservable(bindings.employee_id))
			bindings.employee_id.subscribe((nv) => { this.employee_id(nv); });

		let Bursaries = function(config)
		{
			let data;
			data = $.extend({
				employee_bursary_id: null,
				employee_id: bindings.employee_id,
				degree_name: '',
				institution: '',
				enrolment_date: '',
				subject_name: '',
				subject_code: '',
				exam_date: '',
				result: '0.00',
				notes: '',
				edit_mode: false
			}, config);

			ko.mapping.fromJS(data, {}, this);
		};

		this.add_bursary = () =>
		{
			this.bursaries.unshift(new Bursaries({edit_mode: true}));
			this.edit_allowed(true);
		};

		this.loadPage();
	};

	async loadPage()
	{
		if (this.logged_in_employee_id())
		{
			// load bursaries
			let data = {
				table: 'employee_bursary',
				schema: 'public',
				filter: [{
					field: 'employee_id',
					operand: '=',
					value: this.employee_id()
				}]
			}

			this.loader(true);
			let result = await Grape.fetches.getJSON('/api/record', data);

			if (result.status == 'OK')
			{
				let bursaries = result.records.map(item => ({
					...item,
					edit_mode: ko.observable(false)
				}));
				this.bursaries(bursaries);
			}
			this.loader(false);
		}
	};

	/* Bursary functions start */
	async edit_bursary(data)
	{
		data.edit_mode(true);
		this.edit_allowed(true);
	};

	async save_bursary(data)
	{
		let value = ko.mapping.toJS(data);

		if (value.employee_bursary_id == '')
			value.employee_bursary_id = null;

		value.employee_id = this.employee_id();

		//Validation
		let valid = true;
		let msg = "";

		if (!value.degree_name)
		{
			valid = false;
			msg = tr('Please enter degree name.');
		}
		else if (!value.institution)
		{
			valid = false;
			msg = tr('Please enter an institution name.');
		}
	 	else if (!value.enrolment_date)
		{
			valid = false;
			msg = tr('Please enter enrolment date.');
		}
		else if (!value.subject_name)
		{
			valid = false;
			msg = tr('Please enter a subject name.');
		}
		else if (!value.subject_code)
		{
			valid = false;
			msg = tr('Please enter a subject code.');
		}
		else if (!value.exam_date)
		{
			valid = false;
			msg = tr('Please enter an exam date.');
		}
		else if (value.result > 100)
		{
			valid = false;
			msg = tr('Exam result cannot be more than 100%.');
		}

		if (valid == true)
		{
			let res = await Grape.fetches.postJSON('/employee/save_employee_bursary', value);

			if (res.status == 'OK')
			{
				await Grape.alerts.alert({ type: 'success', message: tr('Successfully saved bursary.'), title: tr('Success') });
				this.loadPage();
				this.edit_allowed(false);
			}
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.bursaries.shift(); // remove the one we were trying to add again.
			} else if (res.error)
			{
				Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error') });
				this.bursaries.shift(); // remove the one we were trying to add again.
			} else
			{
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
				this.bursaries.shift(); // remove the one we were trying to add again.
			}
		}
		else
		{
			Grape.alerts.alert({ type: 'error', message: msg, title: 'Validation Failure' });
			return;
		}
	};

	async delete_bursary(data)
	{
		let options = ko.mapping.toJS(data);

		if (options.employee_bursary_id && options.employee_bursary_id != '')
		{
			let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this Bursary?')});

			if (response)
			{
				let res = await Grape.fetches.postJSON('/employee/delete_employee_bursary', options);
				
				if (res.status == 'OK')
				{
					await Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted bursary.'), title: tr('Success') });
					this.loadPage();

					if (this.edit_allowed() == true)
						this.edit_allowed(false);
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
			}
		}
		else
		{
			this.edit_allowed(false);
			this.bursaries.shift();
		}
	};

	show_bursaries_help()
	{
		Grape.dialog.open('BursariesHelp', { employee_id: this.employee_id() });
	}
}

export default {
	name: 'employee_view_bursaries_component',
	viewModel: EmployeeViewBursariesComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_view_bursaries_component'
};
